import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { isCapabilityEnabled } from 'owa-capabilities';
import { addinsDrawerPaneUnderRibbonCapability } from 'owa-capabilities-definitions/lib/addinsDrawerPaneUnderRibbonCapability';

/**
 * True when `paneId` is the add-in drawer pane rendered under the ribbon (mail reading pane
 * or calendar event form) rather than overlaying the whole window.
 */
export function isUnderRibbonAddinsPane(paneId?: string): boolean {
    return (
        paneId === getDrawerPaneId('addins') &&
        isCapabilityEnabled(addinsDrawerPaneUnderRibbonCapability)
    );
}
